import request from '@/utils/request'
import Vue from 'vue'


// 专家问题列表
export function getQuestionListPage(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/professional-information/getQuestionListPage',
        params
    })
}

// 问题类型
export function selectListByType(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/sys-dict-code/selectListByType',
        params
    })
}

// 问题详情
export function questionDetail(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/professional-information/questionDetail',
        params
    })
}
// 专家回答
export function expertAnsweringQuestion(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/professional-information/expertAnsweringQuestion',
        data
    })
}

// 专家列表
export function getExpert(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/professional-information/getExpert',
        data
    })
}

// 专家详情
export function expertDetail(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/professional-information/expertDetail',
        params
    })
}

export function upload(data,params) {
    return request({
      method: 'POST',
      url:Vue.prototype.baseURL + `/brand/file/upload`,
      data,
      params
    })
  }
// 问题提交
export function submitQuestions(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/professional-information/submitQuestions',
        data
    })
}

//我的提交--交易
export function getTransactionListByUserId(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/personalCenter/getTransactionListByUserId',
        params
    })
}

//我的提交--撮合
export function getMatchUpListByUserId(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/personalCenter/getMatchUpListByUserId',
        params
    })
}
//交易更新
export function TransactionListUpdate(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/transaction/fs-transaction/update',
        data
    })
}

//撮合更新
export function matchUpdate(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/matchUp/fs-matchup/update',
        data
    })
}